import React, { useState } from "react";
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Switch } from "react-native";
import { RouteProp, useRoute } from "@react-navigation/native";
import { observer } from "mobx-react";
import { blogCategoryStore } from "../stores/BlogCategoryStore";
import { IBlogCategory } from "@interfaces/iblogCategory";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import { Theme } from "../enum/Theme";
import { goBack } from "../services/NavigationService";
import { Language } from "@constants/language";
import { LanguageSelector } from "../comps/LanguageSelector";
import { uuidv4 } from "@utils/idUtils";


type CategoryFormRouteProp = RouteProp<{ [EnumRoutesAppWeb.createEditCategory]: { category?: IBlogCategory } }, EnumRoutesAppWeb.createEditCategory>;

const BlogCategoryForm = observer(() => {
  const route = useRoute<CategoryFormRouteProp>();
  const category = route.params?.category;

  const [lang, setLang] = useState<Language>(category?.lang ?? Language.PT);
  const [title, setTitle] = useState(category?.title || "");
  const [active, setActive] = useState(category?.active ?? true);

  const handleSave = async () => {
    const data: IBlogCategory = {
      id: category?.id || uuidv4(),
      lang,
      title,
      active,
    };
    await blogCategoryStore.saveCategory(data);
    goBack();
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{category ? "Editar Categoria" : "Nova Categoria"}</Text>


      <TextInput
        placeholder="Título"
        value={title}
        onChangeText={setTitle}
        style={styles.input}
      />

      <LanguageSelector value={lang} onChange={setLang} />

      <View style={styles.switchContainer}>
        <Text>Ativo:</Text>
        <Switch value={active} onValueChange={setActive} />
      </View>

      <TouchableOpacity style={styles.saveButton} onPress={handleSave}>
        <Text style={styles.saveButtonText}>Salvar</Text>
      </TouchableOpacity>
    </View>
  );
});

export default BlogCategoryForm;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  title: { fontSize: 22, fontWeight: "bold", marginBottom: 20 },
  input: { borderWidth: 1, borderColor: "#ccc", borderRadius: 5, padding: 10, marginBottom: 15 },
  switchContainer: { flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: 20 },
  saveButton: { backgroundColor: Theme.foreground, padding: 15, borderRadius: 5 },
  saveButtonText: { color: "#fff", textAlign: "center", fontWeight: "bold" },
});
